import React from 'react';
import {SegmentedControl} from './SegmentedControl';
import {Scale} from './Scale';
import {ScoreMarker} from './ScoreMarker';

type SegmentedScaleProps = {
  options: string[];
  selectedGradientColors?: string[];
  selectedGradientLocations?: number[];
  selectedOption: string;
  score: number;
};

const SegmentedScale: React.FC<SegmentedScaleProps> = React.memo(
  ({options, selectedOption, selectedGradientColors, selectedGradientLocations, score}) => (
    <div style={{display: 'flex', flexDirection: 'column', padding: '0 22px', width: '100%', boxSizing: 'border-box'}}>
      <SegmentedControl
        options={options}
        selectedOption={selectedOption}
        selectedGradientColors={selectedGradientColors}
        selectedGradientLocations={selectedGradientLocations}
      />
      <Scale start={1} end={27} labelEvery={7} />
      <ScoreMarker start={1} end={27} score={score} style={{top: -50}} />
    </div>
  ),
);

export default SegmentedScale;
